import React, { memo } from 'react';
import { List } from 'immutable';
import Popup from '../../helpers/Popup';
import FormGroup from '../../helpers/FormGroup';
import Button from '../../helpers/Button';
import BaseSelect from '../../helpers/Select';
import BaseInput from '../../helpers/Input';
import ErrorDisplay from '../../decorators/DisplayError';
import PrettyError from '../../decorators/PrettyError';

const Input = PrettyError(ErrorDisplay(BaseInput));
const Select = PrettyError(ErrorDisplay(BaseSelect));

const InternationalFormatComponent = ({ isNew, phoneCodes = List(), onChange, channel, onSave, onUndo, onBlur }) => {
  const header = <div>{`${isNew ? 'Create' : 'Change'} contact profile info`} - International</div>;

  const footer = [
    <Button key="undo" onClick={onUndo}>
      Undo
    </Button>,
    <Button key="save" className="btn-primary" onClick={onSave}>
      {isNew ? 'Create' : 'Save'}
    </Button>,
  ];

  return (
    <Popup footer={footer} header={header} id="extFormatContact">
      <div className="row">
        <FormGroup className="col-sm-3">
          <BaseInput
            className="input-md"
            label="Country Code"
            maxLength="10"
            name="code"
            placeholder="Country Code"
            root={channel}
            deep
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-sm-3">
          <Input
            className="input-md"
            label="Phone"
            maxLength="50"
            name="unformattedPhone"
            onChange={onChange}
            placeholder="Phone"
            root={channel}
            autoFocus
            deep
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-sm-3">
          <Select
            className="input-md"
            label="Country"
            name="country"
            nameKey="name"
            onBlur={onBlur}
            onChange={onChange}
            options={phoneCodes}
            placeholder="Country"
            root={channel}
            valueKey="code"
            canDisplayError
            deep
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-sm-3">
          <BaseInput
            className="input-md"
            label="Type"
            name="type"
            placeholder="Type"
            value="International"
            readOnly
            showLabel
          />
        </FormGroup>
      </div>
    </Popup>
  );
};

export const InternationalFormat = memo(InternationalFormatComponent);
